import { render, staticRenderFns } from "./PositionForm.vue?vue&type=template&id=2f877572&scoped=true"
import script from "./PositionForm.vue?vue&type=script&lang=ts"
export * from "./PositionForm.vue?vue&type=script&lang=ts"
import style0 from "./PositionForm.vue?vue&type=style&index=0&id=2f877572&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f877572",
  null
  
)

export default component.exports